<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="convenientIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a  href="javascript:void(0)" @click="urlTo('convenientIndex')">便民查询</a>/<a  href="javascript:void(0)" style="color: #b7b7b7" @click="urlTo('communitySearch',{code:code,name:title})">{{title}}查询</a><span>/{{title}}详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="personal" style="width: 100%;">
            <div class="personal_right" style="width: 100%;">
              <el-card class="box-card" shadow="hover"
                       style="width: 100%;font-size: 14px;"
              >

                <div v-for="(item,index) in  dataObjList" class="text detail"  style="line-height: 40px; margin-left: 30px;margin-right: 30px;margin-top: 20px" >

                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">区 &nbsp;&nbsp; &nbsp; 划：{{item.party}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.lastTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">网点名称：{{item.ciName}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">办公地址：{{item.workAddress}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">办公时间：{{item.workRemark}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">联系电话：{{item.tel}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">成立时间：{{item.createdDate}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>



                  <div style="height: 50px;width: 100%;"></div>
                </div>

              </el-card>
              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import BaiduMap from "vue-baidu-map/components/map/Map.vue"
  import BmView from 'vue-baidu-map/components/map/MapView.vue'
  import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
  export default {
    name: "SuggestDetail",
    components: {
      headers, fixedDiv, footers,
      BaiduMap,
      BmView,
      BmLocalSearch,
    },
    data() {
      return {
        detail: {},
        detail_id: '',
        html_url: '',
        title: '',
        code: '',
        itemData:null,
        active: 0,
        dataObjList: [],
        tabName: '投诉',
        type:'1',


        location: {
        },
        maps:{},
        lng:'',
        lat:'',
      }
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.title=this.$route.query.title;
      //返回上一页需要的code
      this.code=this.$route.query.code;
      this.getDetail();
    },
    methods: {
      //获取政策文件详细
      getDetail() {
        var _wdid='';
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        const options={
          detailId:this.detail_id,
        };
        var t=this;
        this.$https.post("api/community/getCommunityService.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.dataList && response.data.data.dataList.length>0){
              t.dataObjList=response.data.data.dataList;
              t.total=response.data.data.total;
            }
          }
        })
      },
      //下载附件
      downloadAttach() {
        // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
        // });
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/search/CommunitySearchDetail.vue